/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesBlockDatas.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Block Data Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, October 28, 2018 - 06:48:21 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      10/28/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const BlockDataList = Loadable({
    loader: () => import('../containers/BlockDatas/BlockDataListContainer'),
    loading: Loading,
});

export const BlockDataForm = Loadable({
    loader: () => import('../containers/BlockDatas/BlockDataEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesBlockDatas.js